import { useEffect } from 'react';
import { generatePageTitle } from '../lib/brandUtils';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
}

export const useSEO = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl
}: SEOProps) => {
  useEffect(() => {
    // 設定頁面標題
    if (title) {
      document.title = title;
    }

    // 設定 meta 標籤
    const setMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // 設定 Open Graph 標籤
    const setOGTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // 基本 SEO 標籤
    if (description) {
      setMetaTag('description', description);
    }
    if (keywords) {
      setMetaTag('keywords', keywords);
    }

    // Open Graph 標籤
    if (ogTitle) {
      setOGTag('og:title', ogTitle);
    }
    if (ogDescription) {
      setOGTag('og:description', ogDescription);
    }
    if (ogImage) {
      setOGTag('og:image', ogImage);
    }
    if (ogUrl) {
      setOGTag('og:url', ogUrl);
    }

    // 清理函數 - 當組件卸載時恢復預設標題
    return () => {
      document.title = generatePageTitle();
    };
  }, [title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl]);
};